export default {
    state: {
        url: '/api/hms/signatures',
        signatures: [],
        signature: [],
        signature_id: null,
        files: [],
        errors: {},
        form: {
            facility_id: '',
            date: null,
            contents: [],
            notes: '',
        },
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'id',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'date', label: 'Date', sortable: true, tdClass: 'text-muted'},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'address', label: 'Address', tdClass: 'text-muted'},
                {key: 'occupied_units', label: 'Occupied Units', tdClass: 'text-muted'},
                {key: 'total_signed', label: 'Signs Received', tdClass: 'text-muted'},
                {key: 'sign_percentage', label: '% of Signs', thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
    },

    getters: {
        getSignature: state => state.signature,

        getSignatureFiles: state => state.files,

        getSignatureTableFields: state => state.table.fields,

        getSignaturesMeta: state => state.meta,

        getSignatureErrors: state => state.errors,

        getSignatureForm: state => state.form,
    },

    mutations: {
        setSignatures: (state, payload) => {
            state.signatures = payload;
        },

        setSignature: (state, payload) => {
            state.signature_id = payload.signature_id;
            state.signature = payload;
        },

        setSignaturesMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setSignatureErrors: (state, payload) => {
            state.errors = payload;
        },

        setSignatureFiles: (state, payload) => {
            state.files = payload;
        },

        setSignatureForm: state => {
            state.form = {
                facility_id: '',
                date: null,
                contents: [],
                notes: '',
            };

            state.errors = {};
        },

        resetSignaturesMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'id',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },
    },

    actions: {
        fetchSignatures: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setSignatures', response.data);

                        commit('setSignaturesMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setSignatureErrors', error.response.data.errors);

                        reject(error);
                    });
            });
        },

        fetchSignatureFiles: ({state, commit}, signature_id) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/hms/signatures/' + signature_id + '/attachments')
                    .then(response => {
                        commit('setSignatureFiles', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitSignature: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setBillingErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        fetchEditSignature: ({state, commit}, signature_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + signature_id + '/edit')
                    .then(response => {
                        state.signature_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        updateSignature: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.signature_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setSignatureErrors', error.response.data.errors);

                        reject(error);
                    });
            })
        },

        deleteSignature: ({state, commit}, signature_id) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + signature_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

        fetchSignature: ({state, commit}, signature_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + signature_id)
                    .then(response => {
                        commit('setSignature', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
    }
}
